import { styled } from "styled-components";

export const DropdownContainer = styled.div`
  display: flex;
  margin-bottom: 10px;
  justify-content: center;
  align-items: center;
  margin-left: 50px;
`;
